
import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'
import Vue from 'vue'

export default {
  name: 'OrganizationPropertyContacts',
  extends: CardPropertyTable,
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      addFn: () => this.onAdd() // @Override
    }
  },
  computed: {
    columns: function () {
      const columns = []
      if (this.tabProp.editable) {
        columns.push(this.getColumnConfig({
          name: 'edit',
          label: '',
          type: '_btn',
          sortable: false,
          componentProps: {
            onClick: this.onEdit,
            icon: 'mdi-square-edit-outline'
          }
        }))
      }
      columns.push(this.getColumnConfig({ name: 'fio', label: 'ФИО контактного лица', align: 'left', field: 'fio', sortable: true }))
      columns.push(this.getColumnConfig({ name: 'phone', label: 'Телефон', align: 'left', field: 'phone', sortable: false }))
      columns.push(this.getColumnConfig({ name: 'email', label: 'Адрес электронной почты', align: 'left', field: 'email', sortable: false }))
      return columns
    },
    dataColumns: function () {
      return this.columns.filter(column => !(column.componentProps && column.componentProps.type === '_btn'))
    }
  },
  methods: {
    onAdd: function () {
      const propsConfig = {}
      for (const column of this.dataColumns) {
        propsConfig[column.name] = {
          type: 'text',
          label: column.label
          // required: true
        }
      }

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.onAddConfirm(data)
          }
        },
        header: 'Добавление записи',
        propsConfig: propsConfig,
        buttons: [
          { key: 'yes', name: 'Добавить', color: 'green' },
          { key: 'no', name: 'Отмена', color: 'white' }
        ]
      })
    },
    onAddConfirm: function (record) {
      let columnsValues = this.object[this.tabProp.key]
      if (!columnsValues || Array.isArray(columnsValues) && columnsValues.length === 0) {
        columnsValues = {}
        this.$set(this.object, this.tabProp.key, columnsValues)
      }
      addServerFormatTableRecord(this.dataColumns, columnsValues, record)
    },
    onEdit: function (record) {
      const propsConfig = {}
      for (const column of this.dataColumns) {
        propsConfig[column.name] = {
          type: 'text', // TODO обработать все типы
          label: column.label,
          value: record[column.name]
          // required: true
        }
      }

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const index = this.rows.indexOf(record)
            const recordEdited = Object.assign({}, record, data)
            this.onEditConfirm(record, index, recordEdited)
          }
        },
        propsConfig: propsConfig,
        buttons: [
          { key: 'yes', name: 'Сохранить', color: 'green' },
          { key: 'no', name: 'Отмена', color: 'white' }
        ]
      })
    },
    onEditConfirm: function (record, index, recordEdited) {
      const columns = this.dataColumns
      const columnsValues = this.object[this.tabProp.key]
      setServerFormatTableRecord(columns, columnsValues, record, index, recordEdited)
    }
  }
}

export function addServerFormatTableRecord (columns, columnsValues, record) {
  if (columns && columns.length && columnsValues && typeof columnsValues === 'object') {
    // const columnsKeys = Object.keys(columnsValues)
    for (const column of columns) {
      const columnKey = column.name
      let columnValues = columnsValues[columnKey]
      if (!columnValues) {
        columnValues = []
        // columnsValues[columnKey] = columnValues
        Vue.set(columnsValues, columnKey, columnValues)
      }

      const columnValue = record[columnKey]
      columnValues.push(columnValue)
    }
  }
}

export function setServerFormatTableRecord (columns, columnsValues, record, index, recordEdited) {
  if (columns && columns.length && columnsValues && typeof columnsValues === 'object') {
    for (const column of columns) {
      const columnKey = column.name
      const columnValues = columnsValues[columnKey]

      const columnValue = recordEdited[columnKey]
      columnValues.splice(index, 1, columnValue)
    }
  }
}
